import controller from './contact-detail.controller';
import templateBase from './templates/contact-detail.view.html';
import templateT15 from './templates/contact-detail-t15.view.html';
import templateAD from './templates/contact-detail-adaptative.html';

let ContactDetailComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
  let response = SessionService.get('components');

  if(__env.adaptative) {
    return templateAD;
  } else {
    if (response.CONTACT_DETAIL.component == 'template_t15') { return templateT15; }
    else {
      return templateBase;
    }
  }
}

export default ContactDetailComponent


// WEBPACK FOOTER //
// ./www/components/contact-detail/contact-detail.component.js